import { IVeterinarioContext } from "./Interfaces/IVeterinarioContext";
import {
  VeterinarioActionKeys,
  VeterinarioActionUnion,
} from "./Veterinario.Actions";

export const INITIAL_STATE: IVeterinarioContext = {
  isLoading: false,
  result: {
    data: [],
    success: false,
    pageIndex: 1,
    pageSize: 3,
  },
  allVets: [],
};

export const VeterinarioReducers = (
  state = INITIAL_STATE,
  action: VeterinarioActionUnion
): IVeterinarioContext => {
  switch (action.type) {
    case VeterinarioActionKeys.GET_ALL_VETERINARIOS_SUCCESS: {
      const page_number = 1;
      const page_size = 3;
      const vets = action.payload.data.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
      return {
        ...state,
        allVets: action.payload.data,
        result: {
          ...action.payload,
          data: vets,
          pageSize: 3,
          pageIndex: 1,
        },
      };
    }
    case VeterinarioActionKeys.NEXT_PAGE_VETERINARIOS_SUCCESS: {
      const page_number = (state.result.pageIndex || 1) + 1;
      const page_size = state.result.pageSize || 3;
      let vets = state.allVets.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
      if (!vets || vets.length <= 0) {
        vets = state.allVets.slice((1 - 1) * 3, 1 * 3);
      }
      return {
        ...state,
        result: {
          ...state.result,
          data: vets,
          pageSize: page_size,
          pageIndex: page_number,
        },
      };
    }
    case VeterinarioActionKeys.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
};
